import { TipoDocumentoDto } from "src/app/pagamento/models/tipo-documento-dto";

export const TIPO_DOCUMENTO_DTO: TipoDocumentoDto[] = [
  { codigo: 5, descricao: "DARF - 5 PARCELAS", nomeAbreviado: "DARF 5 PARC" },
  { codigo: 6, descricao: "DARF AZUL", nomeAbreviado: "DARF AZUL" },
  { codigo: 8, descricao: "DARF SIMPLES", nomeAbreviado: "DARF SIMPLES" },
  { codigo: 2, descricao: "DARF VERDE - 4 PARCELAS", nomeAbreviado: "DARF 4 P VERDE" },
  { codigo: 4, descricao: "DOCUMENTO DE ARRECADAÇÃO DE RECEITAS FEDERAIS", nomeAbreviado: "DARF" },
  { codigo: 10, descricao: "DOCUMENTO DE ARRECADAÇÃO DO E-SOCIAL", nomeAbreviado: "DAE" },
  { codigo: 9, descricao: "DOCUMENTO DE ARRECADAÇÃO DO SIMPLES NACIONAL", nomeAbreviado: "DAS" },
  { codigo: 7, descricao: "DOCUMENTO PARA DEPÓSITO JUDICIAL E EXTRA JUDICIAL", nomeAbreviado: "DJE" },
  { codigo: 11, descricao: "GUIA DA PREVIDÊNCIA SOCIAL", nomeAbreviado: "GPS" }
];